import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["location", "link", "interviewType"]

  connect() {
    this.toggleFields() // Set initial state when the page loads
  }

  toggleFields() {
    const selectedType = this.interviewTypeTarget.value

    if (selectedType === "phone") {
      this.locationTarget.classList.add("hidden")
      this.linkTarget.classList.add("hidden")
    } else if (selectedType === "in_person") {
      this.locationTarget.classList.remove("hidden")
      this.linkTarget.classList.add("hidden")
    } else if (selectedType === "online") {
      this.locationTarget.classList.add("hidden")
      this.linkTarget.classList.remove("hidden")
    }
  }
}

